import Swiper from 'swiper';
import { FreeMode, Mousewheel, Navigation, Scrollbar } from 'swiper/modules';

/**
 * Init the related recipes carousel.
 *
 * @param {HTMLElement} rootElement - The carousel root element.
 * @return {void}
 */
function initRelatedRecipesCarousel( rootElement ) {
	const container = rootElement.closest( '.rte-carousel--container' );
	const navigation = {
		enabled: true,
		prevEl: container.querySelector( '.swiper-button-prev' ),
		nextEl: container.querySelector( '.swiper-button-next' ),
	};

	const swiper = new Swiper( rootElement, {
		enabled: false,
		createElements: true,
		modules: [ FreeMode, Mousewheel, Navigation, Scrollbar ],
		mousewheel: { releaseOnEdges: true, forceToAxis: true, enabled: true },
		slidesPerView: 2,
		slideClass: 'rte-carousel--slide',
		spaceBetween: 16,
		wrapperClass: 'rte-carousel--wrapper',
		loop: true,
		navigation,
		breakpoints: {
			640: {
				slidesPerView: 3,
			},
			1025: {
				slidesPerView: 3,
				scrollbar: {
					hide: false,
					draggable: true,
					enabled: true,
					el: '.swiper-scrollbar',
				},
				navigation,
				freeMode: { enabled: true, sticky: true },
				spaceBetween: 24,
				touchRatio: 1,
				longSwipesRatio: 0.5,
			},
		},
		scrollbar: {
			hide: false,
			draggable: true,
			enabled: true,
			el: '.swiper-scrollbar',
		},
		touchRatio: 2,
		longSwipes: true,
		longSwipesRatio: 0.1,
	} );

	// The block renders one group, so the carousel always starts disabled and enables here.
	swiper.enable();
	swiper.scrollbar.updateSize();
}

export default initRelatedRecipesCarousel;
